const rawApiBaseUrl = process.env.REACT_APP_API_URL || '';

export const API_BASE_URL = rawApiBaseUrl.replace(/\/+$/, '');

if (!API_BASE_URL) {
  throw new Error('REACT_APP_API_URL is required');
}
